import { Tooltip } from "@mantine/core";
import classes from "./SkillCard.module.css";

export type Skill = string | { label: string; description: string };

export type SkillCardData = {
  title: string;
  skills: Skill[];
};

export const SkillCard = ({ title, skills }: SkillCardData) => {
  const renderSkill = (skill: Skill, index: number) => {
    const label = typeof skill === "string" ? skill : skill.label;
    const description =
      typeof skill === "string" ? undefined : skill.description;

    const item = (
      <span
        className={
          description
            ? `${classes["skill"]} ${classes["skill-has-desc"]}`
            : classes["skill"]
        }
        key={`${label}_${index}`}
      >
        {label}
      </span>
    );

    if (!description) return item;

    return (
      <Tooltip
        key={`${label}_${index}`}
        label={description}
        multiline
        maw={220}
        withArrow
        events={{ hover: true, focus: true, touch: true }}
      >
        {item}
      </Tooltip>
    );
  };

  return (
    <div className={classes["skill-row"]}>
      <div className={classes["skill-cat"]}>{title}</div>
      <div className={classes["skill-list"]}>{skills.map(renderSkill)}</div>
    </div>
  );
};
